import { useDebounce } from 'use-debounce';
import {
  ExternalMetadataProvider,
  SignalSubjectParentGoal,
} from '@momentum/types';
import { useRelatedSignals } from './useRelatedSignals';

interface UseDebouncedRelatedSignalsParams {
  title: string;
  description: string;
  source?: ExternalMetadataProvider;
  externalId?: string;
  parentGoal?: SignalSubjectParentGoal;
  initialQuery?: { title: string; description: string };
}

export const useDebouncedRelatedSignals = ({
  title,
  description,
  source = ExternalMetadataProvider.NATIVE,
  externalId,
  parentGoal,
  initialQuery,
}: UseDebouncedRelatedSignalsParams) => {
  const trimmedTitle = title.trim();
  const trimmedDescription = description.trim();
  const wordCount = trimmedTitle.split(' ').filter(Boolean).length;
  const hasMinimumWords = wordCount >= 4;

  const isUnchangedInitial =
    initialQuery &&
    trimmedTitle === initialQuery.title.trim() &&
    trimmedDescription === (initialQuery.description ?? '').trim();

  const query = {
    subject: {
      source,
      externalId,
      title: trimmedTitle,
      description: trimmedDescription,
      parentGoal,
    },
  };
  const [debouncedQuery] = useDebounce(query, 1000);

  const { data: signals = [], isFetching } = useRelatedSignals(
    debouncedQuery,
    hasMinimumWords && !isUnchangedInitial
  );

  const isLoading = hasMinimumWords && !isUnchangedInitial && isFetching;

  return { signals, isLoading };
};
